module.exports = __webpack_public_path__ + "90d75c785a865f27d18046dfdd190b5f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-21.png
// module id = 1772
// module chunks = 0